import { useState } from "react";
import Container from "@mui/material/Container";
import Header from "component/Header/Header";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import { FormControl, TextField, InputLabel } from "@mui/material";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import MailEnviado from "component/MailEnviado/MailEnviado";
import { recoverPassword } from "component/api";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import Grid from "@mui/material/Grid";
import "./Register.css";

const Register = () => {
  const [messageError, setMessageError] = useState(false);
  const [deshabilitar, setDeshabilitar] = useState();
  const [error, setError] = useState(false);
  const [messageErrorText, setMessageErrorText] = useState("");

  async function recoverPasswordFunc(cc) {
    await recoverPassword(cc)
      .then((response) => {
        setMailEnviado(true);
      })
      .catch(() => {
        // Same endpoint and same finding as RecuperarContraseña: this screen wording the error
        // from a 403 or a 404 was the second door onto the same customer directory. Recovery
        // answers 200 for every cuenta contrato now, so landing here means the request never
        // completed, not that the account is or is not real.
        setError(true);
        formik.setFieldError("cuenta", " ");
        setDeshabilitar(true);
        setMessageError(true);
        setMessageErrorText(
          "No pudimos procesar tu solicitud. Volvé a intentar en unos minutos."
        );
      });
  }

  let history = useNavigate();

  const [mailEnviado, setMailEnviado] = useState(false);

  const validation = Yup.object().shape({
    cuenta: Yup.string().required("requerido"),
  });
  const formik = useFormik({
    initialValues: {
      cuenta: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      const { cuenta } = values;
      recoverPasswordFunc(cuenta);
    },
  });

  function onChangeCuentaContrato(value) {
    formik.setFieldValue("cuenta", value);
    setMessageError(false);
    setError(false);
    setDeshabilitar(false);
  }

  return (
    <div>
      <Header />

      <div>
        <Container maxWidth="sm">
          <br />
          {mailEnviado === false && (
            <div>
              <Button
                onClick={() => history(-1)}
                startIcon={<ArrowBackIosIcon />}
                style={{
                  marginLeft: "0%",
                  width: "8%",
                  textTransform: "none",
                  backgroundColor: "white",
                  color: "blue",
                }}
              >
                Volver
              </Button>
              <h1>Creá tu contraseña</h1>
              <p>
                Ingresando tu número de cuenta podrás generar tu contraseña.
              </p>
              <br />
              <div>
                <form
                  onSubmit={formik.handleSubmit}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <FormControl className="form-control-register">
                    <InputLabel
                      style={{ color: error === true ? "red" : "black" }}
                    >
                      Número Cuenta
                    </InputLabel>

                    <TextField
                      className="text-field-register"
                      onChange={(event) => {
                        onChangeCuentaContrato(event.target.value);
                      }}
                      // onChange={formik.handleChange}

                      style={{ marginBottom: "2%" }}
                      placeholder="000000000000"
                      // disabled={deshabilitar}
                      id="cuenta"
                      name="cuenta"
                      variant="outlined"
                      helperText={formik.errors.cuenta}
                      error={formik.errors.cuenta}
                    />
                  </FormControl>

                  {messageError === true && (
                    <div
                      style={{
                        backgroundColor: "#F9CDD0",
                        border: "red 1px ridge",
                        width: "80%",

                        marginBottom: "10px",
                      }}
                    >
                      <Grid container sx={{ width: "100%" }}>
                        <Grid size={{ xs: 2 }}>
                          <ErrorRoundedIcon
                            fontSize="large"
                            color="secondary"
                            style={{ marginTop: "25%", marginLeft: "25%" }}
                          />
                        </Grid>
                        <Grid size="grow">
                          <p>{messageErrorText}</p>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={deshabilitar}
                    style={{
                      width: "30%",
                      marginLeft: "25%",
                      marginTop: "5%",
                      textTransform: "none",
                      color: "white",
                      backgroundColor:
                        deshabilitar === true ? "#B1B0AF" : "#009BDB",
                    }}
                  >
                    Enviar
                  </Button>
                </form>
              </div>
            </div>
          )}
          {mailEnviado === true && (
            <div>
              <MailEnviado words={"crear"} />
            </div>
          )}
        </Container>
      </div>
    </div>
  );
};

export default Register;
